export default "__VITE_ASSET__48040b40__"